<template>
<div>
  <v-dialog width="800" v-model="dialog">
    <v-btn block color="primary" slot="activator">
      <v-icon>add</v-icon>
    </v-btn>
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('roles.add') }}
      </v-card-title>
      <create-role :allowedPermissions='permissions' @exit="roleCreated">
      </create-role>
    </v-card>
  </v-dialog>
  <v-data-table :rows-per-page="pagination.rowsPerPage" :pagination.sync="pagination" :headers="headers" :items="roles" class="elevation-1">
    <template slot="headers" slot-scope="props">
      <tr>
        <th class="text-overflow header aqua-color">
          <span class="span-blcok"> Rola </span>
        </th>
        <th v-for="(header,index) in props.headers" :key="header.name+'_'+index" class="text-overflow header">
          <span class="span-blcok"> {{ role.translatePermission(header.name) }} </span>
        </th>
        <th class="narrow-header text-overflow header">
          <span class="span-blcok"> Akcje </span>
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <td class="text-xs-center aqua-color">{{ role.translateRole(props.item.name)}}</td>
      <td v-for="(header,index) in headers" :key="header.name+'_v_'+index" class="text-xs-center">
        <v-checkbox class="span-blcok" disabled :input-value="(props.item.permissions.includes(header.name))" required></v-checkbox>
      </td>
      <td class="text-xs-center">
        <v-btn  v-if="!role.isProtectedRole(props.item.name)"  color="deep-orange darken-3" fab small  dark @click="deleteRole(props.item.name)">
          <v-icon dark>delete_forever</v-icon>
        </v-btn>
        <v-dialog v-model="rbacEditDialog[props.item.name]" width="800">
          <template v-slot:activator="{on}">
            <v-btn v-if="!role.isProtectedRole(props.item.name)" color="primary" fab small style="float:left" @click="rbacEditDialog[props.item.name]=true"
                   v-on="on">
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <RbacEdit v-on:updated="updatedRole($event)" :permisions="permissions" :role-edit="props.item"></RbacEdit>
        </v-dialog>
      </td>

    </template>
  </v-data-table>
</div>
</template>
<script>
import Role from '@/plugins/Role'
import UserRules from '@/mixins/UserRules'
import CreateRole from './dialogs/CreateRole'
import RbacEdit from "@/components/user/RbacEdit"
import Messenger from "@/plugins/Messenger"

export default {
  components: {
    RbacEdit,
    CreateRole
  },
  mixins: [UserRules],
  data() {
    return {
      pagination: {
        rowsPerPage: 25,
      },
      role: new Role(),
      dialog: false,
      permissions: [],
      roles: [],
      rbacEditDialog: [],
      passwordRules: [v => (!!v || !this.changePass) || this.$t('user.create.error.empty-pass')],
    }
  },
  computed: {
    headers() {
      return this.permissions.map(el => ({
        name: el.name,
        value: el.name
      }))
    }
  },
  created() {
    this.loadRbacRoles()
    this.loadPermission()
  },
  methods: {
    loadRbacRoles() {
      this.axios.get('rbac/roles')
        .then(data => this.roles = data.data)
        .catch(() => Messenger.emitError("Problem z załadowaniem roli"))
    },
    loadPermission() {
      this.$http.get('rbac/permissions')
        .then(data => this.permissions = data.data)
        .catch(() => Messenger.emitError("Problem z załadowaniem uprawnien"))
    },
    deleteRole(roleName) {
      this.axios.delete('rbac/roles/' + roleName)
        .then(() => this.roles = this.roles.filter(role => role.name != roleName))
        .catch(() => Messenger.emitError("Problem z usunięciem roli"))
    },
    roleCreated(role) {
      this.dialog = false
      this.roles.push(role)
    },
    updatedRole(role){
      Object.assign(this.roles.find(r => r.name == role.name), role)
      this.rbacEditDialog[role.name] = false
    }
  },
}
</script>


<style>
.text-overflow {
  text-align: center;
  word-wrap: break-word;
  align: center;
  vertical-align: middle;

}

.center {
  margin: 0 auto;
}

.span-blcok {
  display: inline-block;
  height: 50px;
  white-space: normal;
}

.header {
  width: 200px !important;
}

.aqua-color {
  background-color: #e6faff;
}
</style>
